<template>
  <b-container>
    <b-row align-h="between" style="margin-left: 0; margin-right: 0;">
      <h3>Hinweise:</h3>
      <div>
        <b-button variant="outline-primary" to="Hinweis/Neu">Erstellen</b-button>
      </div>
    </b-row>
    <hr class="mt-4 mb-4">
    <b-list-group>
      <draggable v-model="warnings" handle=".handle" @change="savePositions()">
        <b-list-group-item
            v-for="warning in warnings" :key="warning.position"
        >
          <b-row>
            <b-col>
              <router-link :to="{ path: `Hinweis/${warning.id}`}">{{ warning.title }}</router-link>
            </b-col>
            <b-col cols="1">
              <b-icon :style="{ background: warning.color }"/>
            </b-col>
            <b-col cols="1">
              <b-icon-trash @click="confirmDeleteWarning(warning.id)"></b-icon-trash>
            </b-col>
            <b-col cols="1">
              <b-icon-list class="handle"></b-icon-list>
            </b-col>
          </b-row>
        </b-list-group-item>
      </draggable>
    </b-list-group>
  </b-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  name: 'WarningListe',
  computed: {
    ...mapGetters([
      'getStoredWarnings',
    ]),
    warnings: {
      get() {
        return this.getStoredWarnings
      },
      set(warnings) {
        this.storeWarnings(warnings)
      }
    },
  },
  methods: {
    ...mapActions([
      'getWarnings',
      'saveWarningPositions',
      'deleteWarning',
    ]),
    ...mapMutations([
      'storeWarnings',
    ]),
    savePositions() {
      let warnings = this.warnings.map((e, index) => e = {id: e.id, position: index})
      this.saveWarningPositions(warnings)
    },
    confirmDeleteWarning(warningId) {
      this.$bvModal.msgBoxConfirm('Wollen Sie den Hinweis wirklich löschen ?', {
        title: 'Löschen',
        okVariant: 'outline-danger',
        okTitle: 'Ja',
        cancelTitle: 'Abbrechen',
        cancelVariant: 'outline-success',
        centered: true
      })
          .then(value => {
            if (value) {
              this.deleteWarning(warningId)
            }
          })
    },
  },
  mounted() {
    this.getWarnings()
  }
}
</script>

<style scoped>

</style>
